var _style, _path, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 17",
    style: {
      enableBackground: "new 0 0 20 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{mask:url(#mask0_1_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,17c-0.3,0-0.5-0.1-0.7-0.3L1.5,8.9c-2-2-2-5.4,0-7.4c1-1,2.3-1.5,3.7-1.5s2.7,0.5,3.7,1.5L10,2.6l1.1-1.1 c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5c2,2,2,5.4,0,7.4l-7.8,7.8C10.5,16.9,10.3,17,10,17z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.2,2C4.4,2,3.5,2.3,2.9,2.9c-1.3,1.3-1.3,3.3,0,4.6l7.1,7.1l7.1-7.1c1.3-1.3,1.3-3.3,0-4.6 c-1.2-1.2-3.3-1.2-4.6,0l-1.8,1.8c-0.4,0.4-1,0.4-1.4,0L7.5,2.9C6.9,2.3,6.1,2,5.2,2z M10,17c-0.3,0-0.5-0.1-0.7-0.3L1.5,8.9 c-2-2-2-5.4,0-7.4c1-1,2.3-1.5,3.7-1.5s2.7,0.5,3.7,1.5L10,2.6l1.1-1.1c1-1,2.3-1.5,3.7-1.5c1.4,0,2.7,0.5,3.7,1.5c2,2,2,5.4,0,7.4 l-7.8,7.8C10.5,16.9,10.3,17,10,17z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.474b5d43.svg";
export { ForwardRef as ReactComponent };